import { useForm } from "react-hook-form";
import { AnswerInput } from "../AnswerInput";
import { MultipleAnswerInput } from "../MultipleAnswerInput";
import { useEffect, useRef } from "react";
import { Chip } from "../Chip";
import { getStep3Data } from "../../helper";

export const Step3 = ({
  questions = [],
  answers = {},
  updateAnswer,
  warmapQuestionResponse = {},
}) => {
  const step3Data = getStep3Data(warmapQuestionResponse);

  const defaultValues = questions.reduce((acc, question) => {
    if (!question.allow_multiple_answers) {
      acc[String(question.id)] =
        answers[question.id] || question?.answer?.answer_text || "";
    }
    return acc;
  }, {});

  const { control, setValue } = useForm({
    defaultValues,
  });

  const prevAnswersRef = useRef(answers);

  useEffect(() => {
    questions.forEach((question) => {
      if (!question.allow_multiple_answers) {
        const questionId = String(question.id);
        const currentAnswer = answers[question.id];
        const prevAnswer = prevAnswersRef.current[question.id];

        if (currentAnswer !== prevAnswer && currentAnswer !== undefined) {
          setValue(questionId, currentAnswer, { shouldDirty: false });
        }
      }
    });

    prevAnswersRef.current = { ...answers };
  }, [answers, questions, setValue]);

  return (
    <div className="d-flex flex-column w-full" style={{ gap: "24px" }}>
      {/* Chip Data part */}
      <div className="d-flex flex-row justify-content-center align-items-center w-full">
        <Chip
          label="Non-Negotiable Power Up"
          content={`${step3Data.completed_habits_count} / ${step3Data.total_habits_count}`}
        />
      </div>

      {questions?.length > 0 &&
        questions.map((question) => {
          if (question.allow_multiple_answers) {
            return (
              <MultipleAnswerInput
                key={question.id}
                questionId={question.id}
                label={question.question_text}
                defaultValue={
                  answers[question.id] || question?.answer?.answer_text || ""
                }
                onValueChange={(value) => {
                  if (updateAnswer) {
                    updateAnswer(question.id, value);
                  }
                }}
              />
            );
          }

          return (
            <AnswerInput
              control={control}
              key={question.id}
              name={String(question.id)}
              label={question.question_text}
              defaultValue={
                answers[question.id] || question?.answer?.answer_text || ""
              }
              onValueChange={(value) => {
                if (updateAnswer) {
                  updateAnswer(question.id, value);
                }
              }}
            />
          );
        })}
    </div>
  );
};
